import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-yellow-400 rounded-lg flex items-center justify-center">
                <i className="ri-brush-line text-black text-xl"></i>
              </div>
              <span className="text-2xl font-bold">Cape Town Painters</span>
            </div>
            <p className="text-gray-300 mb-8 max-w-md text-lg leading-relaxed">
              Our platform connect you to professional painting services in Cape Town. Providing high-quality interior and exterior painting for residential and commercial properties with unmatched expertise and reliability.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-2xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-2xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer">
                <i className="ri-twitter-line text-2xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-2xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6 text-white">Services</h3>
            <ul className="space-y-4">
              <li><Link to="/services/interior-painting" className="text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer text-base">Interior Painting</Link></li>
              <li><Link to="/services/exterior-painting" className="text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer text-base">Exterior Painting</Link></li>
              <li><Link to="/services/commercial-painting" className="text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer text-base">Commercial Painting</Link></li>
              <li><Link to="/services/roof-painting" className="text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer text-base">Roof Painting</Link></li>
              <li><Link to="/services/waterproofing" className="text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer text-base">Waterproofing</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6 text-white">Contact Info</h3>
            <div className="space-y-4 text-gray-300">
              <Link 
                to="/contact"
                className="flex items-center space-x-3 text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line text-yellow-400 text-lg"></i>
                <span className="text-base">Get a quote</span>
              </Link>
              <div className="flex items-center space-x-3">
                <i className="ri-map-pin-line text-yellow-400 text-lg"></i>
                <span className="text-base">Cape Town, Western Cape</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-time-line text-yellow-400 text-lg"></i>
                <span className="text-base">Mon-Fri: 7:30-17:00</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-base">
            © {currentYear} Cape Town Painters. All rights reserved.
          </p>
          <div className="flex items-center space-x-6 mt-4 sm:mt-0">
            <Link to="/privacy" className="text-gray-400 hover:text-yellow-400 text-sm transition-colors cursor-pointer">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-400 hover:text-yellow-400 text-sm transition-colors cursor-pointer">
              Terms of Service
            </Link>
            <a 
              href="https://seostudio.co.za/" 
              className="text-gray-400 hover:text-yellow-400 text-sm transition-colors cursor-pointer"
              rel="nofollow"
            >
              SEO by SEO Studio
            </a>
            <a 
              href="https://leaderr.co/" 
              className="text-gray-400 hover:text-yellow-400 text-sm transition-colors cursor-pointer"
              rel="nofollow"
            >
              Powered by leaderr
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
}
